<template>
    <video id="video-background" src="/assets/dipocaco/video/fog.mp4" autoplay muted loop></video>
</template>

<script>
export default {
    name: "AnimatedBackgroundVideo",
    data() {
        return {};
    },
    mounted() {
        this.$store.commit('updateUserData');
    },
    computed: {},
    watch: {},
    methods: {
        //
    },
};
</script>

<style scoped lang="scss">
#video-background {
    display: inline-block;
    position: fixed;
    bottom: 0;
    z-index: -1;
    min-width: 100vw;
}
</style>